import type { Theme } from '@mui/material/styles';

export const textFieldStyles = (theme: Theme) => ({
  '& label': {
    color: theme.palette.text.primary,
    '&.Mui-focused': {
      color: theme.palette.text.primary,
      borderColor: theme.palette.bidlogiq?.orange,
    },
    '&.MuiInputLabel-shrink': {
      fontSize: '.9rem',
    },
  },
  '& .MuiFormHelperText-root': {
    fontSize: '.8rem',
    color: theme.palette.text.primary,
    marginTop: '2px',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.bidlogiq?.orange,
      borderWidth: '2px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.bidlogiq?.orange,
      borderWidth: '2px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.greyContrast,
      borderWidth: '1px',
    },
    '&.Mui-error': {
      backgroundColor: theme.palette.bidlogiq?.rust50,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.bidlogiq?.rust50,
        borderWidth: '2px',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.bidlogiq?.rust50,
        borderWidth: '2px',
      },
    },
  },
});
